/* eslint-disable no-unused-vars */
import { ReactElement, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { SubjectWrapper, ListItemWrapper } from './subcomponents'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
  resetChapters,
  setSelectedChapter
} from '../../../../redux/learn/actions'
import { RootState } from '../../../../redux/store'
import { ListItem, Loader, SubHeader } from '../../../../components'
import ROUTES from '../../../../const/routes'
import strings from '../../../../locale/en'
import { capitalize } from '../../../../helpers'
import { getSubjectLogo } from '../../../../helpers'
import { getLearnSession } from '../../../../redux/learnSession/api'

const Chapters = (): ReactElement => { 
  const { isLoading, chapters, sessionData } = useSelector(
    (state: RootState) => ({
      isLoading: state.learn?.isLoading,
      chapters: state.learn?.chapters,
      sessionData: state.learnSession.getAllSession
    }),
    shallowEqual
  )

  const history = useHistory()
  const dispatch = useDispatch()
  const { subjectName = '', list = [] } = chapters
  const logo = getSubjectLogo({
    subject: subjectName
  })
  const dropdownList = [
    { name: 'Topic', id: 'topic' },
    { name: 'Session', id: 'section' }
  ]
  const initialValues = {
    dp: ''
  }
  const [values, setValues] = useState(initialValues)

  useEffect(() => {
    dispatch(getLearnSession())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SubjectWrapper id="container">
      <SubHeader
        title={subjectName}
        handleBack={() => {
          dispatch(resetChapters())
          history.goBack()
        }}
        logo={logo}
        subTitle={`${list?.length} ${capitalize(strings.learn.chapters)}`}
        // dropdownList={dropdownList}
        handleDropdownSelect={(item) => {
          setValues({
            ...values,
            dp: item?.name
          })
        }}
      />
      
        <ListItemWrapper>
          {isLoading ? (
            <Loader /> 
          ) : (
            list?.map((chapter, index) => (
              <ListItem
                id={`chapter-list-${index}`}
                title={chapter?.courseName}
                key={`chapter-${index}`}
                index={index}
                subTitle={`${chapter?.videoCount} ${strings.learn.materials}, ${chapter?.topicMaterialResponses?.length} ${strings.learn.topics}`}
                onSelect={() => {
                  dispatch(setSelectedChapter(chapter?.id))
                  history.push(ROUTES.TOPICS)
                }}
              />
            ))
          )}
        </ListItemWrapper> 
      {/* {values?.dp === 'Session' && (
        <ListItemWrapper>
          {sessionData.map((data) => (
            data?.courseSessionDetailDao.map((list, index) => (
              <ListItem
                title={list?.chapter}
                index={index}
                key={index}
              />
            ))


          ))}
        </ListItemWrapper>
      )} */}
    </SubjectWrapper>
  )
}

export default Chapters
